<!-- even though there is a default value for height and width, the *ngIf -->
<!-- is necessary because IE takes a while to update [style] bindings -->
<div *ngIf="height && width" class="d-flex my-0 mx-auto" [style.height.rem]="height / 16" [style.width.rem]="width / 16">
  <svg class="spinner" [class.spinner-white]="white" viewBox="0 0 50 50" [style.height.rem]="height / 16" [style.width.rem]="width / 16">
    <circle class="fixed-path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
  </svg>
</div>
